<template>
    <div class="pw-ipt-wrap">
      <base-input-wrap title="重置密码" :disabled="disabled" :showIptWrap="showIptWrap" @close-ipt-wrap="close" @confirm="confirm">
        <div v-if="showResetTypeTabs" class="reset-type-tab">
          <span
            class="item"
            :class="{ active: resetType === 'phone' }"
            @click="resetType = 'phone'"
          >
            手机号重置
          </span>
          <span
            class="item"
            :class="{ active: resetType === 'email' }"
            @click="resetType = 'email'"
          >
            邮箱重置
          </span>
        </div>
        <template v-if="resetType === 'phone'">
          <base-input v-model="form.phone" ph="" :disabled="true"/>
          <yz-input v-model="form.phoneCode" :phone="form.phone" @focus="errCode = ''" :errCode="errCode" />
        </template>
        <template v-else>
          <base-input v-model="form.email" ph="" :disabled="true"/>
          <yz-input
            v-model="form.emailCode"
            scene="email"
            action="reset_password"
            :email="form.email"
            @wrongEmail="errCode = '请输入正确的邮箱'"
            @focus="errCode = ''"
            :errCode="errCode"
          />
        </template>
        <p v-if="errCode" class="err">{{errCode}}</p>
        <base-input 
          type="password" 
          :isPassword="true" 
          v-model="form.newPw" 
          ph="输入新密码" 
          :limitLen="16" 
          @focus="DoublePasswordErr = passwordTestErr = ''"
          @blur="form.newPw.length !== 0 && !validPassword(form.newPw) ? passwordTestErr = '请输入8-16位数字、字母组合的密码' : ''"
          :warning="passwordTestErr"
        ></base-input>
        <p v-if="passwordTestErr" class="err">{{passwordTestErr}}</p>
        <base-input 
          type="password" 
          :isPassword="true" 
          v-model="form.repeatNewPw" 
          ph="重复新密码" 
          :showTips="true" 
          :limitLen="16"
          @focus="DoublePasswordErr = ''"
          @blur="form.repeatNewPw.length !== 0 && form.repeatNewPw !== form.newPw ? DoublePasswordErr = '两次密码不一致' : ''"
          :warning="DoublePasswordErr"
        ></base-input>
        <p v-if="DoublePasswordErr" class="err">{{DoublePasswordErr}}</p>
        <p class="title">密码必须是8-16位的数字、字母组合（不能是纯数字）</p>
      </base-input-wrap>
    </div>
</template>

<script>
import baseInputWrap from './base-input-wrap'
import baseInput from './base-input'
import yzInput from './yz-input'
// encryption
import encryption from '@/assets/js/encryption.js'

export default {
    data() {
        return {
          showIptWrap: false,
          form: {
            phone: '',
            email: '',
            phoneCode: '',
            emailCode: '',
            newPw: '',
            repeatNewPw: ''
          },
          errCode: '',
          passwordTestErr: '',
          DoublePasswordErr: '',
          authStrategy: 1,
          resetType: 'phone'
        }
    },
    computed: {
      disabled() {
        return !(this.currentCode && this.validPassword(this.form.newPw) && this.validPassword(this.form.repeatNewPw))
      },
      currentCode() {
        return this.resetType === 'email' ? this.form.emailCode : this.form.phoneCode
      },
      canUseEmailReset() {
        return Number(this.authStrategy) === 2 && !!this.form.email
      },
      canUsePhoneReset() {
        return !!this.form.phone
      },
      showResetTypeTabs() {
        return this.canUsePhoneReset && this.canUseEmailReset
      }
    },
    methods: {
      open(options = {}) {
        this.form.phone = options.phone || '';
        this.form.email = options.email || '';
        this.form.phoneCode = '';
        this.form.emailCode = '';
        this.form.newPw = '';
        this.form.repeatNewPw = '';
        this.errCode = '';
        this.passwordTestErr = '';
        this.DoublePasswordErr = '';
        this.authStrategy = Number(options.authStrategy) || 1;
        this.resetType = this.form.phone ? 'phone' : 'email'
        this.showIptWrap = true;
      },

      close() {
        this.showIptWrap = false;
        this.form.phoneCode = ''
        this.form.emailCode = ''
        this.form.newPw = ''
        this.form.repeatNewPw = ''
        this.errCode = ''
        this.passwordTestErr = ''
        this.DoublePasswordErr = ''
      },

      confirm() {
        if (this.pwLock) return;
        if (!this.validPassword(this.form.repeatNewPw)) {
          // return this.openMessage(0, '密码格式不正确');
          return this.passwordTestErr = '请输入8-16位数字、字母组合的密码'
        }
        this.passwordTestErr = ''
        if(this.form.newPw !== this.form.repeatNewPw) {
          // return this.openMessage(0, '两次输入的密码不一致');
          return this.DoublePasswordErr = '两次密码不一致'
        }
        this.DoublePasswordErr = ''
        this.pwLock = true;
        const password = encryption(this.form.repeatNewPw)
        const request = this.resetType === 'email'
          ? this.$fetch.post({
            url: '/password/reset-by-email',
            params: {
              email: this.form.email,
              code: this.form.emailCode,
              password
            }
          })
          : this.$fetch.put({
            url: '/user?method=update_password&password=' + password + '&code=' + this.form.phoneCode
          })
        request.then(data => {
          if (data.success) {
            this.openMessage(1, '修改成功');
            this.showIptWrap = false;
            this.close()
          }
        }, e => {
          this.errCode = e.error_text
          // this.openMessage(0, '修改失败')
        })
        .finally(() => setTimeout(() => this.pwLock = false, 500));
      },

      validPassword(str) {
        const numReg = /^[0-9]{8,16}$/;
        const strReg = /^[a-zA-Z]{8,16}$/;
        const pwdReg = /^[a-zA-Z0-9]{8,16}$/;
        if (!numReg.test(str) && !strReg.test(str) && pwdReg.test(str)) {
          return true;
        }
        return false;
      }
    },
    components: {
      baseInputWrap,
      baseInput,
      yzInput
    }
}
</script>

<style lang="scss" scoped>
.pw-ipt-wrap {
  position: relative;
  z-index: 100;
}

.reset-type-tab {
  display: flex;
  margin-top: 10px;
  overflow: hidden;
  border-radius: 6px;
  background: #EFF2F4;

  .item {
    flex: 1;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #666666;

    &.active {
      color: #FFFFFF;
      background: #08A681;
    }
  }
}

.title {
  font-size: 12px;
  padding-top: 10px;
  padding-left: 4px;
}

.err {
  padding: 10px 0 0 4px;
  font-size: 12px;
  color: #E51C23;
}
</style>
